<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    {{ $t('message.title_change_link_admin_dialog') }}
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <p class="dialog-target-tenant">{{ targetTenant.tenantName }}</p>
                    <el-select
                        v-model="selectedUserId"
                        :placeholder="$t('message.item_link_admin')"
                        class="admin-select"
                    >
                        <el-option
                            v-for="user in selectableAdminUserList"
                            :key="user.userId"
                            :label="`${user.displayName}（${user.userName}）`"
                            :value="user.userId"
                        />
                    </el-select>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button
                        class="dialog-ok-button"
                        :disabled="selectedUserId === null || saving"
                        @click="save"
                        v-t="'message.button_save'"
                    ></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "@/components/ServerApi.js";
import constants from "@/components/constants";
import commonUtil from "@/components/commonutil";

/**
 * 企業間通信管理者変更ダイアログ。
 * 候補ユーザーの取得・変更APIの呼び出しを自身で行う自己完結型コンポーネント。
 * 変更成功時に saved を emit する（リスト再取得は親の責務）。
 */
export default {
    name: "LinkTenantSettingChangeAdmin",
    emits: ["saved", "cancel"],
    props: {
        targetTenant: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            adminUserList: [],
            selectedUserId: null,
            saving: false,
        };
    },
    computed: {
        // 現在の管理者は変更先の選択肢から除外する
        selectableAdminUserList() {
            return this.adminUserList.filter(user => user.userId !== this.targetTenant.wantUserId);
        },
    },
    async created() {
        await this.fetchAdminUserList();
    },
    methods: {
        async fetchAdminUserList() {
            try {
                const res = await server.post('/getuserlistbyrights', { rights: 'tenantadmin' });
                if (res.data.status !== constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getuserlistbyrights").replace("{code}", res.data.status));
                    this.$emit("cancel");
                    return;
                }
                this.adminUserList = res.data.userList ?? [];
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getuserlistbyrights", e);
                this.$emit("cancel");
            }
        },
        async save() {
            if (this.selectedUserId === null || this.saving) return;
            this.saving = true;
            try {
                const res = await server.post('/changeimporttenantwantuser', {
                    importTenantId: this.targetTenant.tenantId,
                    newUserId: this.selectedUserId,
                });
                if (res.data.status === constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_link_admin_changed"));
                    this.$emit("saved");
                } else {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "changeimporttenantwantuser").replace("{code}", res.data.status));
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "changeimporttenantwantuser", e);
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.dialog-target-tenant {
    font-weight: bold;
    margin-bottom: 12px;
    color: #333;
}
.admin-select {
    width: 100%;
}
</style>
